module.exports = __webpack_public_path__ + "img/pdf-icon.41ef7895.png";